import React, { useState } from "react";
import { router } from "@inertiajs/react";

interface LoginProps {
  csrf_token: string;
}

const Login = ({ csrf_token }: LoginProps) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [processing, setProcessing] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setProcessing(true);

    router.post(
      "/users/sign_in",
      {
        user: {
          email: email,
          password: password,
          remember_me: rememberMe,
        },
        authenticity_token: csrf_token,
      },
      {
        onFinish: () => setProcessing(false),
      }
    );
  };

  return (
    <div className="flex min-h-screen items-center flex-col justify-center px-6 py-12 lg:px-8 bg-gradient-to-br from-blue-400 via-blue-50 to-blue-300">
      <h1 className="text-4xl tracking-tight font-semibold mb-5 text-gray-900">
        Resolute<span className="text-blue-500 text-4xl">.</span>
      </h1>
      <div className="mx-auto w-full max-w-[400px] bg-white rounded-xl p-7 pt-4 border">
        <h2 className="text-[24px] text-center font-semibold leading-9 text-gray-800 mb-0">
          Log in
        </h2>

        <form onSubmit={handleSubmit} className="mt-6">
          <div className="mb-4">
            <label
              htmlFor="email"
              className="block text-[14px] font-medium text-gray-900 mb-1"
            >
              Email
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoFocus
              autoComplete="email"
              placeholder="name@emailresolute.com"
              className="block w-full rounded-lg border border-gray-200 h-10 px-3 py-2 text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              required
            />
          </div>

          <div className="mb-4">
            <label
              htmlFor="password"
              className="block text-[14px] font-medium text-gray-900 mb-1"
            >
              Password
            </label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              className="block w-full rounded-lg border border-gray-200 h-10 px-3 py-2 text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              required
            />
          </div>

          <div className="mb-6 flex items-center">
            <input
              id="remember-me"
              type="checkbox"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
              className="h-4 w-4 rounded border-gray-300 text-blue-500 focus:ring-blue-500"
            />
            <label
              htmlFor="remember-me"
              className="ml-2 text-[14px] text-gray-600"
            >
              Remember me
            </label>
          </div>

          <div>
            <button
              type="submit"
              disabled={processing}
              className="w-full items-center justify-center whitespace-nowrap rounded-md bg-gradient-to-b from-blue-500 to-blue-600 px-5 py-2.5 text-center text-base font-medium text-white shadow-sm transition-all duration-100 ease-in-out hover:opacity-90 dark:text-white cursor-pointer disabled:opacity-50"
            >
              {processing ? "Logging in..." : "Log in"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

// Explicitly set layout to return the page without any wrapper
Login.layout = (page: React.ReactNode) => page;

export default Login;